import { render, staticRenderFns } from "./SetupPureHuawei.vue?vue&type=template&id=64d53c5e"
import script from "./SetupPureHuawei.vue?vue&type=script&lang=js"
export * from "./SetupPureHuawei.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports